export default __webpack_public_path__ + "static/media/tab-icon-3-sm.e2fa7c8e.svg";